import { createAsyncThunk } from '@reduxjs/toolkit';
import { TenantsViews } from '../../../constants/views';

export const fetchTenants = createAsyncThunk(
  'tenants/fetchTenants',
  async (
    { pageIndex, pageSize, searchQuery, sortOrder, sortedColumnId } = {},
    { rejectWithValue, extra: { gccApiClient } },
  ) => {
    const response = await gccApiClient.getTenants(pageIndex, pageSize, searchQuery, sortOrder, sortedColumnId);
    if (response.error_code) {
      return rejectWithValue({ errorCode: response.error_code });
    }
    const { data, pagination } = response;
    return { data, pagination };
  },
);

export const fetchTenantDetails = createAsyncThunk(
  'tenants/fetchTenantDetails',
  async ({ tenantId } = {}, { rejectWithValue, extra: { gccApiClient } }) => {
    const response = await gccApiClient.getTenantDetails(tenantId);
    if (response.error_code) {
      return rejectWithValue({ errorCode: response.error_code });
    }
    return { tenant: response };
  },
);

export const fetchTenantSelectOptions = createAsyncThunk(
  'tenants/fetchTenantSelectOptions',
  async (_args, { extra: { gccApiClient } }) => {
    const response = await gccApiClient.getTenants(0, 1000, '', null, null, TenantsViews.SELECT_OPTIONS);
    return response?.data;
  },
);
